/*
 *
 * ControlAccessModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
 */
import React from 'react'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import PropTypes from 'prop-types'
import DataRow from 'Components/DataRow'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import formattedMessage from './languageModule'

const ControlAccessModal = (props) => (
  <Toggle>
    <MerchantModal
      title={formattedMessage.modalTitle}
      customAnalyticsDescription={formattedMessage.introText}
      withoutButton
      onClose={() => props.actions.doHidePopup()}
      topBarTitle=' '
    >
      <div className='pciModalContent'>
        <MerchantGenericCard>
          <div className='pciModalContentHeader'>
            <DataRow full label={formattedMessage.protectionLabel} content={formattedMessage.protectionValue} />
            <DataRow full label={formattedMessage.difficultyLabel} content={formattedMessage.difficultyValue} />
          </div>
        </MerchantGenericCard>
        <div className='pciModalContentValidity'>
          <p className='pciModalContentValidityText'>{formattedMessage.validForLabel}</p>
          <div className='pciModalContentValidityBadges'>
            <MerchantTableBadge symbol label={formattedMessage.ecommerceLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.motoLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.faceToFaceLabel} status='brand' />
          </div>
        </div>
        <MerchantGenericCard>
          {formattedMessage.introText}
          <br />
          <br />
          {formattedMessage.privilegeAbuseText}
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise1Title}
            </h1>
            <p>
              {formattedMessage.advise1Text}
            </p>
          </div>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise2Title}
            </h1>
            <p>
              {formattedMessage.advise2Text}
              <br />
              <br />
              {formattedMessage.advise2Text2}
              <br />
              <br />
              {formattedMessage.advise2Text3}
              <br />
              <br />
              {formattedMessage.advise2Text4}
            </p>
          </div>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise3Title}
            </h1>
            <p>
              {formattedMessage.advise3Text}
            </p>
          </div>
        </MerchantGenericCard>
      </div>
    </MerchantModal>
  </Toggle>
)

ControlAccessModal.propTypes = {
  actions: PropTypes.object
}

ControlAccessModal.defaultProps = {
  action: {}
}

export default ControlAccessModal
